import Vue from 'vue'

const state = () => ({
  patientDocuments: []
})

const getters = {}

const actions = {
  async getPatientDocuments({commit}, patientId) {
    const result = await Vue.$http.get(`/patients/${patientId}/documents`)
    if (result?.status === 200) {
      commit('SET_DATA', ['patientDocuments', result.data?.data?.$values || []])
    }
  },
  async uploadPatientDocument({dispatch}, {file, patientId}) {
    const formData = new FormData()

    formData.append('file', file)
    formData.append('patientId', patientId)

    const {data} = await Vue.$http.post('/Documents/patient/upload', formData)

    return data
  },

  async downloadDocumentFile(_, {id}) {
    if (!id) return null

    const {status, data} = await Vue.$http.get(`/Documents/${id}/download`, {
      responseType: 'blob'
    })
    return status === 200 ? data : null
  },

  async removePatientDocument(_, documentId) {
    if (!documentId) return {success: false}

    const result = await Vue.$http.delete(`/Documents/patient/remove/${documentId}`)
    return result?.data || {success: false}
  }
}

const mutations = {
  SET_DATA: (state, payload) => {
    const [property, value] = payload
    Vue.set(state, property, value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
